<app-menu>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class=" col-md-6 col-sm-12 mt-5">
            <div class="row">
              <div class="info-box">
                <h5 class="small-title">Seja bem vindo(a), {{username}}</h5>
                <h2 class="big-title">Portal Externo FGC</h2>
                <div class="buttons-box">
                  <div class="col-12"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-0">
            <div class="img-box">
              <img src="../../../../assets/logos/fgc-logo.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-menu>
